import React from 'react';
import { message, Spin } from 'antd';
import { Redirect, withRouter } from 'react-router-dom'
import BaseLayout from './components/BaseLayout'
import MyRouter from './router'
import common from './common/common.js'
import request from './common/urequest'
import moment from 'moment'
import 'moment/locale/zh-cn'
import './css/main.less'
moment.locale('zh-cn');

class main extends React.Component {
    state = {
        ulogin: false,
        loading: true,
    }

    componentWillReceiveProps(next) {
        if (this.props.location.pathname === next.location.pathname) {
            return false;
        }
        this.authUserLogin();
    }

    componentWillMount() {
        this.authUserLogin();
    }

    authUserLogin = () => {
        const that = this;
        this.setState({ loading: true });
        request('appVendLogin/isUserLogin.action', {
            method: 'POST'
        }).then(d => {
            if (d) {
                if (d.status == '1') {
                    that.setState({ ulogin: true });
                    return false;
                }
            }
            that.setState({ ulogin: false });
        }).finally(() => that.setState({ loading: false }));
    }

    logOut = () => {
        const that = this;
        request('appVendLogin/logout.action', {
            method: 'POST'
        }).then(d => {
            if (d && d.status === "success") {
                that.setState({ ulogin: false });
                common.removeLocalItem();
            } else {
                message.error(d.info);
            }
        });
    }

    toUrl = url => {
        this.props.history.push(url);
    }

    render() {
        const { ulogin, loading } = this.state;
        if (!loading) {
            return (
                ulogin ? <BaseLayout loginOut={this.logOut} history={this.props.history} toUrl={this.toUrl} location={this.props.location}><MyRouter /></BaseLayout> :
                    <Redirect to="/login" />
            )
        } else {
            return <Spin size="large"><div style={{ width: '100%', height: '100%', marginTop: '35%' }}></div></Spin>;
        }
    }
}

export default withRouter(main);